var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('v-snackbar',{staticClass:"rounded",attrs:{"value":_vm.alert,"timeout":2000,"color":_vm.alertType,"centered":"","left":""}},[_vm._v(" "+_vm._s(_vm.alertText)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }